import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Card, Icon } from '@weezevent/nacre';

export default function NoDesignFound({ organization, event }) {
    const history = useHistory();
    const { t } = useTranslation();

    const handleClick = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/${event ? `E${event.id}/settings` : 'tickets_design'}${!event ? '/designs' : ''}`);
    }, [history, organization, event]);

    return (
        <Card.EmptyState
            title={t('ticket.ticket_design.designs.empty.not_found')}
            icon={<Icon name="image" />}
            labelButton={t('ticket.common.action.back')}
            onClick={handleClick}
        />
    );
}
